module.exports = __webpack_public_path__ + "static/media/yesterday.da7d904f.jpg";